export default {
      id: "_2808613807680-usage",
      viewBox: "0 0 31 34",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#_2808613807680",
      toString: function () {
        return this.url;
      }
    }